import PropTypes from "prop-types";
import React, { useState } from "react";
import { InfoModal } from "../InfoModal/InfoModal";
import "./styles.scss";

export const InfoIcon = ({ title, content, size = "21px", className = "" }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <span
        className={`info-icon ${className}`}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick(e);
          }
        }}
        aria-label={`More information about ${title}`}
      >
        <img src="/images/iconInfoSolid.svg" alt="Information" style={{ width: size, height: size }} />
      </span>

      <InfoModal show={showModal} onHide={handleCloseModal} title={title} content={content} />
    </>
  );
};

InfoIcon.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  size: PropTypes.string,
  className: PropTypes.string,
};
